import React from 'react';
import Products from './Products';
import './ProductsPage.css';

const ProductsPage = ({ onBack }) => {
  return (
    <div className="products-page">
      <div className="page-hero" style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ''}/elektrik9.jpeg)` }}>
        <div className="container">
          <h1 className="page-hero-title">Ürünlerimiz</h1>
          <p className="page-hero-subtitle">
            Kalfa Elektrik Elektronik olarak çeşitli elektrik ve elektronik ürünler sunuyoruz.
          </p>
        </div>
      </div>
      <Products showAll={true} />
    </div>
  );
};

export default ProductsPage;
